/**
 * Logging levels
 */
export enum LogLevel {
  Debug = 4,
  Info = 3,
  Warn = 2,
  Error = 1,
}
